import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import { api } from "@/lib/api";
import { motion } from "framer-motion";
import { ArrowRight, Calendar } from "lucide-react";

const CATS = ["All", "Agriculture", "Dairy Industry", "Rural Development", "Company News"];

export default function News() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/news", { params: { category: cat } }).then(r => setItems(r.data)).catch(() => setItems([]));
  }, [cat]);

  return (
    <div data-testid="news-page">
      <PageHero
        eyebrow="News & Insights"
        title={<>Updates from across the <em className="not-italic font-serif italic text-shramik-green">Shramik ecosystem.</em></>}
        subtitle="Company news, industry perspectives and stories of rural transformation."
      />

      <section className="py-14">
        <div className="container-page">
          <div className="flex flex-wrap gap-2 mb-10" data-testid="news-filters">
            {CATS.map(c => (
              <button key={c} onClick={() => setCat(c)} data-testid={`news-filter-${c.toLowerCase().replace(/\s+/g,'-')}`}
                className={`px-4 py-2 rounded-full text-sm font-medium ${cat === c ? "bg-shramik-green text-white" : "bg-slate-100 hover:bg-shramik-greenLight text-slate-700"}`}>{c}</button>
            ))}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="news-grid">
            {items.map((n, i) => (
              <motion.article key={n.id}
                initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once:true}} transition={{duration:0.4, delay:i*0.05}}
                className="group bg-white rounded-3xl border border-slate-100 overflow-hidden card-hover"
                data-testid={`news-${n.id}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={n.cover} alt={n.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"/>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-xs text-slate-500 mb-3">
                    <span className="px-2 py-1 rounded-full bg-shramik-greenLight text-shramik-green font-semibold uppercase tracking-wider">{n.category}</span>
                    <span className="flex items-center gap-1"><Calendar className="w-3 h-3"/> {new Date(n.date).toLocaleDateString('en-IN', { day:'numeric', month:'short', year:'numeric' })}</span>
                  </div>
                  <h3 className="font-display text-xl font-medium leading-tight">{n.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{n.excerpt}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-shramik-green">Read more <ArrowRight className="w-4 h-4"/></div>
                </div>
              </motion.article>
            ))}
          </div>
          {items.length === 0 && <div className="text-center py-16 text-slate-500">No stories in this category yet.</div>}
        </div>
      </section>
    </div>
  );
}
